import React from 'react';
import PropTypes from 'prop-types';
import TextField from './TextField';
import isDate from 'lodash/isDate';
import { parseDate, formatDate } from '../../utils/dateUtils';

class ReportDateField extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			value: props.value,
			valid: this.isValid(props.value),
			displayValue: this.getDisplayValue(props.value),
			isFocused: false
		};

		this.onChange = this.onChange.bind(this);
		this.onBlur = this.onBlur.bind(this);
		this.onFocus = this.onFocus.bind(this);
	}
	UNSAFE_componentWillReceiveProps(nextProps) {
		this.setState({
			value: nextProps.value,
			valid: this.isValid(nextProps.value),
			displayValue: this.getDisplayValue(nextProps.value)
		});
	}
	isValid(value) {
		if (value === null || value === '' || value === undefined) return true;
		const dateValue = formatDate(isDate(value) ? value : parseDate(value), 'dd/MM/yyyy');
		return dateValue !== 'Invalid Date'; 
	}
	getDisplayValue(value) {
		if (value === null || value === '' || value === undefined) return '';
		const dateValue = formatDate(isDate(value) ? value : parseDate(value), 'dd/MM/yyyy');
		const val = dateValue === 'Invalid Date' ? value : dateValue; 
		return val;
	}
	applyDateMask(input) {
		// Remove all non-digits
		const digits = input.replace(/\D/g, '');

		// Apply mask: dd/MM/yyyy
		let masked = '';
		if (digits.length > 0) masked += digits.substring(0, 2);
		if (digits.length > 2) masked += '/' + digits.substring(2, 4);
		if (digits.length > 4) masked += '/' + digits.substring(4, 8);

		return masked;
	}

	onChange(e, v) {
		if (this.props.editable === false) return;
				
		const maskedValue = this.applyDateMask(v);

		this.setState({
			value: maskedValue,
			displayValue: maskedValue
		});
	}
	onFocus() {
		this.setState({ isFocused: true });
	}
	onBlur(e) {
		if (this.props.editable === false) return;
		const v = e.target.value;

		const parsedDate = parseDate(v);
		const formatted = this.isValid(parsedDate) ? this.getDisplayValue(parsedDate) : v;


		this.setState({
			value: v,
			valid: this.isValid(parsedDate),
			displayValue: formatted,
			isFocused: false
		});

		if (this.props.onChange) this.props.onChange(parsedDate, formatted, this.isValid(parsedDate));
	}
	render() {
		const { editable } = this.props;
		const { displayValue, valid, isFocused } = this.state;

		let background = '';
		if (!valid) {
			background = '#F4DCDE';
		}
		
		let classes = 'report-field';
		if (editable !== false) {
			classes += ' editable';
		}

		const style = {
			width: '100px', 
			lineHeight: '14px',
			height: '18px',
			background: background,
			...this.props.style
		};
		const inputStyle = {
			fontSize: '12px', 
			textAlign: 'right',
			padding: '2px',
			...this.props.inputStyle
		};

		// Show placeholder slashes when not focused and value is empty
		const effectiveValue = (!isFocused && (displayValue === '' || displayValue === undefined))
			? '   /   /        '
			: displayValue;

		return (
			<TextField 
				className={classes}
				onChange={this.onChange} 
				onBlur={this.onBlur} 
				underlineShow={false} 
				style={style} 
				inputStyle={inputStyle} 
				value={effectiveValue} 
			/>
		);
	}
}

ReportDateField.propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.func,
	editable: PropTypes.bool,
	style: PropTypes.object,
	inputStyle: PropTypes.object
};

ReportDateField.defaultProps = {
	value: undefined,	
	onChange: () => {},
	editable: false,
	style: {},
	inputStyle: {}
};

export default ReportDateField;
